import React from "react";
import DashboardV2AllGeneral from "./DashboardV2AllGeneral";
import DashboardV2AllServices from "./DashboardV2AllServices";
import DashboardV2AllClients from "./DashboardV2AllClients";
import DashboardV2AllLinguists from "./DashboardV2AllLinguists";
import DashboardV2InterpretationsMonthly from "./DashboardV2InterpretationsMonthly";
import DashboardV2TranslationsMonthly from "./DashboardV2TranslationsMonthly";
import DashboardV2OtherServicesMonthly from "./DashboardV2OtherServicesMonthly";
import DashboardV2InterpretationsWeekly from "./DashboardV2InterpretationsWeekly";
import DashboardV2TranslationsWeekly from "./DashboardV2TranslationsWeekly";
import DashboardV2OtherServicesWeekly from "./DashboardV2OtherServicesWeekly";

const resolveModuleComponent = (moduleRef) => {
  if (!moduleRef) return null;
  if (typeof moduleRef === "function") return moduleRef;
  if (typeof moduleRef === "object" && typeof moduleRef.default === "function") {
    return moduleRef.default;
  }
  return null;
};

// ---------------------------------------------------------------------------
// Module registry — maps each (page × view × overview) combination to the
// V2 module component that should render. Adding a new V2 module only
// requires updating this object + creating the wrapper file.
// ---------------------------------------------------------------------------

/** ALL page — keyed by selectedOverview */
const V2_ALL_MODULES = {
  "General Overview": DashboardV2AllGeneral,
  Services: DashboardV2AllServices,
  Clients: DashboardV2AllClients,
  Linguists: DashboardV2AllLinguists,
};

/** Service pages (non-ALL) — keyed by dashboardPagesTitles index */
const V2_MONTHLY_MODULES = [
  DashboardV2InterpretationsMonthly,
  DashboardV2TranslationsMonthly,
  DashboardV2OtherServicesMonthly,
];

const V2_WEEKLY_MODULES = [
  DashboardV2InterpretationsWeekly,
  DashboardV2TranslationsWeekly,
  DashboardV2OtherServicesWeekly,
];

// ---------------------------------------------------------------------------

const DashboardV2 = ({
  user,
  dateSelection,
  selectedPage,
  selectedView,
  selectedOverview,
  dashboardPagesTitles,
}) => {
  const allIndex = dashboardPagesTitles.indexOf("ALL");
  const isAll = selectedPage === allIndex;
  const isWeekly = selectedView === "Weekly";

  if (isAll) {
    const AllModule = resolveModuleComponent(
      V2_ALL_MODULES[selectedOverview] ?? DashboardV2AllGeneral,
    );
    if (!AllModule) return null;
    return (
      <AllModule
        user={user}
        dateSelection={dateSelection}
        key={`v2-all-${selectedOverview}`}
      />
    );
  }

  if (isWeekly) {
    const WeeklyModule = resolveModuleComponent(V2_WEEKLY_MODULES[selectedPage]);
    if (!WeeklyModule) return null;
    return <WeeklyModule user={user} key={`v2-weekly-${selectedPage}`} />;
  }

  const MonthlyModule = resolveModuleComponent(V2_MONTHLY_MODULES[selectedPage]);
  if (!MonthlyModule) return null;
  return (
    <MonthlyModule
      user={user}
      dateSelection={dateSelection}
      key={`v2-monthly-${selectedPage}`}
    />
  );
};

export default DashboardV2;
